import React from "react";

import { Link } from "react-router-dom";

export default function Contact() {
  return (
    <div>
      <div class="main-sec">
        <div class="banner-wthree-info container">
          <div class="row">
            <div class="col-lg-5 banner-left-info">
              <h3>Contact Us</h3>
            </div>
          </div>
        </div>
      </div>

      {/* <section class="collections">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-8 "> */}
      {/* <img
                src="abs.jpg"
                alt="part image"
                style={{ marginTop: "25px" }}
                class="img-fluid"
              />
              <img
                src="abs.jpg"
                alt="part image"
                style={{ marginTop: "25px" }}
                class="img-fluid"
              />
              <br />
              <img
                src="abs.jpg"
                alt="part image"
                style={{ marginTop: "25px" }}
                class="img-fluid"
              />
              <br /> */}
      {/* <img
                src="bg12.jpg"
                alt="part image"
                style={{ marginTop: "25px" }}
                class="img-fluid"
              />
            </div>
            <div class="col-md-4 ab-content text-center p-lg-5 p-3 my-lg-5">
              <p>
                Untrash is a new startup which aims to help college students to
                get all that they need at a very very cheap rate and once the
                use is done all they have to do is upload the product back and
                they will definetly get new buyers to who all are interested to
                buy their products.
                <br />
              </p>
              <br />
              <p>
                <b>
                  Untrash believe in the healthy cycle of buy sell and repeat!
                </b>
                <br />
                <br />
                Buy a product when you need,use it and sell it again,and the
                cycle goes on just passing product from one person to another
                who needs it.
              </p>
              <br />
              <Link to="/collection" class="btn shop">
                Shop now
              </Link>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
}
